import { authConstants } from "../actions/constants";
import {
    AUTH_SESSION_EXPIRED,
    SESSION_EXPIRED_MESSAGE,
} from "../helpers/authSession";

const initState = {
    token: null,
    user: {
        firstName: "",
        lastName: "",
        email: "",
        picture: ""
    },
    authenticate: false,
    authenticating: false,
    loading: false,
    error: null,
    message: "",
    showAlert: false,
    variantAlert: "",
};

export default (state = initState, action) => {
    switch (action.type) {
        case authConstants.LOGIN_REQUEST:
            return {
                ...state,
                authenticating: true,
                error: null,
                showAlert: false,
                message: "",
            };

        case authConstants.LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
                authenticate: true,
                authenticating: false,
                loading: false,
                error: null,
                showAlert: true,
                variantAlert: "success",
                message: action.payload.message || "",
            };

        case authConstants.LOGIN_FAILURE:
            return {
                ...state,
                token: null,
                authenticate: false,
                message: action.payload?.message || "Не удалось войти",
                authenticating: false,
                showAlert: true,
                variantAlert: "warning",
            };

        case authConstants.LOGOUT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case authConstants.LOGOUT_SUCCESS:
            return {
                ...initState,
                showAlert: true,
                variantAlert: "success",
                message: action.payload?.message || "Вы вышли из аккаунта",
            };

        case authConstants.LOGOUT_FAILURE:
            return {
                ...state,
                showAlert: true,
                variantAlert: "warning",
                message: "Что-то пошло не так!",
                loading: false,
            };

        case authConstants.NEED_TO_LOGIN:
            return {
                ...initState,
                showAlert: true,
                variantAlert: "warning",
                message: action.payload?.message || "Нужно войти в аккаунт",
            };

        case AUTH_SESSION_EXPIRED:
            return {
                ...initState,
                showAlert: true,
                variantAlert: "warning",
                message: action.payload?.message || SESSION_EXPIRED_MESSAGE,
            };

        case authConstants.CLOSE_ALERT_TO_AUTH:
            return {
                ...state,
                showAlert: false,
            };

        default:
            return state;
    }
};

export const setCloseAlertAuth = (payload) => ({
    type: authConstants.CLOSE_ALERT_TO_AUTH,
    payload,
});
